import { IRequest, IRequestError } from "../interfaces/authentication.interface";
import { IResources } from "../interfaces/resources.interface";
import { strapiRequest } from "./requests.service";

export const getResources = async (
    locale: string,
    countryIsoCode?: string
): Promise<IRequest<IResources>> => {
    try {
        const query = `
            query ResourcesAndServices($filters: ResourceAndServiceFiltersInput, $locale: I18NLocaleCode, $status: PublicationStatus) {
                resourcesAndServices(
                    filters: $filters,
                    locale: $locale,
                    status: $status,
                ) {
                    description
                    regions {
                        id
                        region
                        resources {
                            title
                            subsections {
                                subtitle
                                resources {
                                    link {
                                        id
                                        href
                                        text
                                        target
                                    }
                                    logo {
                                        url
                                    }
                                    type
                                    description
                                }
                            }
                        }
                    }
                    resources {
                        title
                        subsections {
                            subtitle
                            resources {
                                link {
                                    id
                                    href
                                    text
                                    target
                                }
                                logo {
                                    url
                                }
                                type
                                description
                            }
                        }
                    }
                }
            }`;

        const variables = {
            filters: {
                country: {
                    isoCode: {
                        eq: countryIsoCode ? countryIsoCode : null
                    }
                },
                type: {
                    eq: countryIsoCode ? "NATIONAL" : "INTERNATIONAL"
                }
            },
            status: "PUBLISHED",
            locale
        };

        const response = await strapiRequest.post<{ data: { resourcesAndServices: IResources[] } }>(
            `/graphql`,
            {
                operationName: "ResourcesAndServices",
                query,
                variables
            }
        );
        
        return { success: true, data: response.data.data.resourcesAndServices[0] ?? { resources: [] } };
    } catch (error: any) {
        return { success: false, data: [] as any };
    }
};